export default __webpack_public_path__ + "static/media/Cat_A_Accessories_V2.5f8722b3.jpeg";